module.exports = __webpack_public_path__ + "img/artwork-2.3c7fc397.png";